import { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory, useLocation } from 'react-router';
import RouteUtils from '../modules/routeUtils';
import useIsMobile from './useIsMobile';

export default function useSearchFilters({ sendToSearchPage }) {
  const location = useLocation();
  const history = useHistory();
  const isMobile = useIsMobile(1080);

  const [searchFilters, setSearchFilters] = useState({});
  const [mapOpen, setMapOpen] = useState(false);

  // Keep refs to latest history/location to avoid recreating setFilters callback
  const historyRef = useRef(history);
  const locationRef = useRef(location);

  useEffect(() => {
    historyRef.current = history;
    locationRef.current = location;
  }, [history, location]);

  // Update search filters based on URL
  useEffect(() => {
    const params = RouteUtils.getQueryParams(location);
    setSearchFilters(params);
  }, [location]);

  // Close map if switching to mobile
  useEffect(() => {
    if (isMobile) {
      setMapOpen(false);
    }
  }, [isMobile]);

  const setFilters = useCallback((params) => {
    if (sendToSearchPage) {
      RouteUtils.updateQueryParam(
        historyRef.current,
        locationRef.current,
        params,
        '/search'
      );
    } else {
      RouteUtils.updateQueryParam(
        historyRef.current,
        locationRef.current,
        params
      );
    }
  }, [sendToSearchPage]);

  return {
    searchFilters,
    setFilters,
    mapOpen,
    setMapOpen,
  };
}
